<template>
<v-main  v-scroll="onScroll">
  <header-common :logo_background="backgroundUrl" :onTop="onTop" :hidden="true" :page_title="'login_customer'" v-on:editContent="editContent"></header-common>
  <v-container class="text-left">
    <v-row>
      <v-col md="3" sm="3">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="menu-title">Menu</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-list-item  class="menu-item" v-for="(item, key) in menu" v-bind:key="key">
            <v-list-item-content>
                <v-list-item-title @click="goTo(item.name)">{{item.title}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col md="9" class="mt-2">
          <div style="color:rgba(0,0,0,.87)!important;font-weight: 700;padding-left: 15px;border-left: 4px solid #1976d2;font-size: 24px;">Mes Dossiers</div>
          <v-timeline
            dense
            clipped
            >
            <v-timeline-item
                class="mb-4"
                color="primary"
                small
            >
                <v-row justify="space-between">
                  <v-col cols="9">
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          Dossier N°202014567 - <b>Pré-Avis d'arrivée prêt à imprimer.</b>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-chip
                          class="white--text ml-0 my-2"
                          color="primary"
                          label
                          small
                          >
                          Avis/Document
                          </v-chip>
                          <v-simple-table dense>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td>Pré-Avis d'arrivée N°20201456 </td>
                                  <td></td>
                                  <td><v-icon small>mdi-printer</v-icon></td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                
                    
                </v-col>
                <v-col
                    class="text-right"
                    cols="3"
                >
                    07/05 15:25 
                </v-col>
                </v-row>
            </v-timeline-item>

            <v-timeline-item
                class="mb-4"
                color="grey"
                small
            >
              <v-row justify="space-between">
                <v-col>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header disable-icon-rotate>
                        Dossier N°145524 - Archive
                        <template v-slot:actions>
                          <v-icon color="teal">
                            mdi-check
                          </v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-chip
                          class="white--text ml-0 my-2"
                          color="primary"
                          label
                          small
                          >
                          Avis/Document
                          </v-chip>
                          <v-simple-table dense>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td>Avis N°20201456 </td>
                                  <td>(Facturé)</td>
                                  <td><v-icon small>mdi-printer</v-icon></td>
                                </tr>
                                <tr>
                                  <td>Fiche de Caisse N°FC20201456 </td>
                                  <td></td>
                                  <td><v-icon small>mdi-printer</v-icon></td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                          <v-chip
                          class="white--text ml-0 my-2"
                          color="primary"
                          label
                          small
                          >
                          Facture(s)
                          </v-chip>
                          <v-simple-table width="100%" dense>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td>Facture B/L N°20201456 </td>
                                  <td>(732,250 TND)</td>
                                  <td><v-icon small>mdi-printer</v-icon></td>
                                </tr>
                                <tr>
                                  <td>Facture Magasinage N°7845623 </td>
                                  <td>(732,250 TND)</td>
                                  <td><v-icon small>mdi-printer</v-icon></td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col
                    class="text-right"
                    cols="3"
                >
                    07/05 15:25 
                </v-col>
              </v-row>
            </v-timeline-item>

            

            </v-timeline>
      </v-col>
    </v-row>
  </v-container>
  <footer-prime></footer-prime>
</v-main>
</template>


<script>
import headerCommon from "../commons/header"
import footerPrime from "../commons/footer"
import logo_light from "../../../assets/logo_light.png"
import logo_dark from "../../../assets/logo_dark.png"
import aboutImg from "../../../assets/section_1.jpg"
import aboutCart from "../../../assets/about_cart.png"

export default {
  name: 'customer-dashboard',
  data: () => ({
      type: ['20" ', '40" '],
      inflammable: false,
      tabs: 'tab2',
      tab: null,
      clientdata: {
        email: '',
        password: ''
      },
      gerbable: false,
      menu: [
          {title: 'Messages', name:'messages'},
          {title: 'Mes Dossiers',name: 'dossiers'},
          {title: 'Factures',name:'factures'},
          {title: 'Paramètres', name:'params'},
          {title: 'Déconnexion', name: 'logout'},
      ],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    page_title: 'services',
    backgroundUrl: logo_light,
    aboutImage: aboutImg,
    aboutCart: aboutCart,
    alert: false,
    onTop: true,
    alertText: ''
    }),
    methods: {
      onScroll() {
        if(document.documentElement.scrollTop === 0 ){
          this.backgroundUrl = logo_light
          this.onTop = true
        }else{
          this.backgroundUrl = logo_dark
          this.onTop = false
        }
      },
      editContent(name){
        //console.log(name+' - index')
        this.$emit("edit", {name: name, page: 'login_customer'})
      },
      goTo(param){
        if(param === 'logout'){
          this.$store.dispatch('logoutCustomer')
          this.$router.push({name: 'loginCustomer'})
        }
      }
    },
    components: {
      headerCommon, footerPrime
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap');
.menu-title{
    font-weight: 700;
    padding-left: 15px;
    border-left: 4px solid #1976d2;
    font-size: 24px;
}
.menu-item{
    font-size: 16px;
    margin:5px 0px;
    transition:all ease-in .2s;
}
.menu-item:hover{
    padding-left: 10px;
}
.hide-customer-area {
  display: none !important;
}
.borderable-btn {
  border:2px solid #1976d2a1;
}
.single-service{
  position:relative;
}
.single-service .hoverable {
  position:absolute;
  width:100%;
  opacity: 0;
  transition: opacity .4s linear .2s;
}
.single-service:hover .hoverable{
  opacity: 1;
}
.quotes {
    background: url('https://i.imgur.com/yOZlJRU.png') no-repeat top left;
    background-size: 80px;
}
.quote-content {
    font-size: 16px;
    line-height: 25px;
    padding: 35px;
}
.list-about .v-icon {
  padding-right:20px;
  color:#1976d2;
}
.step {
    text-align:left;
    color: white;
}
.feature-content{
  font-size: 14px;
  letter-spacing: 1px;
  padding-top: 10px;
  line-height: 26px;
}

.feature-title{
  padding-top: 0px;
  font-size: 18px;
  font-weight: 700;
}
.step-title {
    font-weight:700;
    font-size:18px;
    margin-bottom:15px;
    display: block;
}
.img-content {
    width:100%;
    height:550px;
    background-size:cover !important;
}
*{
  transition: all .3s ease-in;
}
.image-service{
    overflow: hidden;
}
.image-service:hover .img-content {
    transform: scale(1.2);
}
.service-position {
    font-size:36px;
    color: #41abff;
}
.description-service {
    position: absolute;
    bottom: 22px;
    left: 0;
    right: 0;
    width: 95%;
    padding: 0 30px 13px 30px;
    margin: 0 auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    align-items: baseline;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 1;
    font-size:20px;
    font-weight:700;
    color: white;
}
.text-service {
    position: absolute;
    top: 230px;
    left: 25px;
    color: #f3f6f5;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    -webkit-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
    -webkit-transform-origin: 0 0;
    -ms-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: 1;
}

* {
  font-family: 'Inter', sans-serif;
}
.back-head{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(255,255,255,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
.font-back-content{
  color: transparent;
  font-family: Arial, Helvetica, sans-serif !important;
  -webkit-text-fill-color: transparent; /* Will override color (regardless of order) */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: rgba(0,0,0,0.2);
  position: absolute;
  left:0;
  right:0;
  text-transform: uppercase;
  font-size:74px;
  font-weight:900;
}
#header-website .v-btn{
  border-radius: 20px;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headline {
  font-size: 64px;
  text-shadow: 0 0 20px rgba(0,0,0,0.6);
  font-weight: 700;
}
.text-caption{
  width:50%;
  text-align: center;
  margin: 0 auto;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/website/customer/dashboard.vue